import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  ButtonToolbar,
  Dropdown,
  Glyphicon,
  MenuItem,
} from 'react-bootstrap';
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import {
  defineMessages,
  FormattedMessage,
  injectIntl,
  intlShape,
} from 'react-intl';

import render from 'components/ReduxForm/renderField';

const years = [2016, 2017, 2018, 2019, 2020];
const DropdownMenu = Dropdown.Menu;
const DropdownToggle = Dropdown.Toggle;

export const messages = defineMessages({
  year: {
    id: 'filterForm.managedProject.year',
    defaultMessage: 'Year',
    description: 'Label for year field in filter form',
  },
  from: {
    id: 'controlling.managedProject.from',
    defaultMessage: 'From',
    description: 'Label for From field in filter form',
  },
  category: {
    id: 'filterForm.category',
    defaultMessage: 'Category',
    description: 'Label for category in filter form',
  },
  to: {
    id: 'controlling.managedProject.to',
    defaultMessage: 'To',
    description: 'Label for To field in filter form',
  },
  managedProject: {
    id: 'filterForm.managedProject',
    defaultMessage: 'ManagedProject',
    description: 'Label for project field in filter form',
  },
  project: {
    id: 'filterForm.project',
    defaultMessage: 'project',
    description: 'Label for project field in filter form',
  },
  submit: {
    id: 'filterForm.submit',
    defaultMessage: 'Apply',
    description: 'Submit button text in filter form',
  },
  reset: {
    id: 'filterForm.reset',
    defaultMessage: 'Reset',
    description: 'Reset button text in filter form',
  },
  exportFormat: {
    id: 'filterForm.exportFormat',
    defaultMessage: 'Export',
    description: 'Export dropdown text in filter form',
  },
  applyCompensation: {
    id: 'filterForm.applyCompensation',
    defaultMessage: 'Apply Compensation',
    description: 'Apply Compensation button text in filter form',
  },
});

class FilterFormManagedProject extends React.Component {
  static propTypes = {
    projects: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
    ),
    projectCategoriesList: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }),
    ),
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    onReset: PropTypes.func.isRequired,
    onExport: PropTypes.func,
    intl: intlShape.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  static defaultProps = {
    projectCategoriesList: [],
    projects: [],
    onExport: null,
  };

  constructor(props) {
    super(props);

    this.handleDatepickerChange = this.handleDatepickerChange.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
    this.handleExportFormatChange = this.handleDatepickerChange.bind(this);

    this.yearSelectRef = React.createRef();
    this.typeSelectRef = React.createRef();
    this.exportSelectRef = React.createRef();
    this.projectCategoriesSelectRef = React.createRef();
  }

  handleYearChange(e, value) {
    if (value) {
      this.props.dispatch(change('filterForm', 'from', null));
      this.props.dispatch(change('filterForm', 'to', null));
    }
  }

  handleDatepickerChange(e, value) {
    if (value) {
      this.props.dispatch(change('filterForm', 'year', null));
    }
  }

  handleExportFormatChange(e, value) {
    if (value) {
      this.props.onExport(e, value);
    }
  }

  render() {
    const { projectCategoriesList } = this.props;
    const exportFormats = [
      {
        label: 'PDF',
        value: 'pdf',
      },
      {
        label: 'XLSX',
        value: 'xlsx',
      },
    ];
    const formats = exportFormats.map(fmt => (
      <MenuItem key={fmt.value} eventKey={fmt.value}>
        {fmt.label}
      </MenuItem>
    ));
    return (
      <form onSubmit={this.props.handleSubmit}>
        <fieldset>
          <Row>
            <Col xs={12} md={2}>
              <Field
                id="year"
                name="year"
                onChange={(e, value) => this.handleYearChange(e, value)}
                label={<FormattedMessage {...messages.year} />}
                component={render.renderSelectAlt}
                options={years.map(year => ({
                  label: year,
                  value: year,
                }))}
                selectRef={this.yearSelectRef}
              />
            </Col>
            <Col xs={12} md={2}>
              <Field
                id="from"
                name="from"
                onChange={(e, value) => this.handleDatepickerChange(e, value)}
                label={<FormattedMessage {...messages.from} />}
                component={render.renderDate}
              />
            </Col>
            <Col xs={12} md={2}>
              <Field
                id="to"
                name="to"
                label={<FormattedMessage {...messages.to} />}
                component={render.renderDate}
              />
            </Col>
            <Col xs={12} md={5}>
              <Field
                name="projectCategoriesList"
                label={<FormattedMessage {...messages.category} />}
                placeholder={<FormattedMessage {...messages.category} />}
                options={
                  projectCategoriesList
                    ? projectCategoriesList.map(category => ({
                        label: category.label,
                        value: category.value,
                      }))
                    : []
                }
                disabled={
                  !Array.isArray(projectCategoriesList) ||
                  projectCategoriesList.length === 0
                }
                component={render.renderMultiSelect}
              />
            </Col>
          </Row>
          <ButtonToolbar>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={this.props.submitting}
            >
              <FormattedMessage {...messages.submit} />
            </button>
            <button
              type="button"
              className="btn"
              disabled={this.props.submitting}
              onClick={this.props.onReset}
            >
              <FormattedMessage {...messages.reset} />
            </button>
            {this.props.onExport && (
              <Dropdown
                id="exportDropdown"
                onSelect={(e, value) => this.props.onExport(e, value)}
              >
                <DropdownToggle className="btn dropdown-toggle">
                  <Glyphicon glyph="export" />
                  <FormattedMessage {...messages.exportFormat} />
                </DropdownToggle>
                <DropdownMenu>{formats}</DropdownMenu>
              </Dropdown>
            )}
          </ButtonToolbar>
        </fieldset>
        <hr />
      </form>
    );
  }
}

export default reduxForm({
  form: 'filterForm',
})(connect()(injectIntl(FilterFormManagedProject)));
